(function () {
  var cfg = window.CGX_SS;
  if (!cfg || !cfg.data) return;
  var PLATFORMS = [
    { key: 'ig', qty: /instagram\s*sticker/i, handle: /instagram\s*handle/i },
    { key: 'tt', qty: /tiktok\s*sticker/i, handle: /tiktok\s*handle/i }
  ];
  var data = null;
  var imgs = {};
  var loading = null;
  var tries = 0;

  function assetUrl(file) {
    return cfg.data.replace(/ss-styles\.json(\?.*)?$/, file);
  }

  function load() {
    if (loading) return loading;
    loading = fetch(cfg.data).then(function (r) { return r.json(); }).then(function (d) {
      data = d;
      var waits = [];
      Object.keys(d).forEach(function (p) {
        imgs[p] = {};
        d[p].parts.map(function (o) { return o.file; }).concat(d[p].sheet).forEach(function (file) {
          waits.push(new Promise(function (res, rej) {
            var im = new Image();
            im.onload = res;
            im.onerror = rej;
            im.src = assetUrl(file);
            imgs[p][file] = im;
          }));
        });
      });
      return Promise.all(waits);
    });
    return loading;
  }

  function clean(v, max) {
    return v.replace(/^@+/, '').replace(/[^A-Za-z0-9._]/g, '').slice(0, max).toUpperCase();
  }

  function draw(cv, len, p, text) {
    var set = data[p], im = imgs[p];
    var items = [], x = 0;
    for (var ch of text) {
      var g = set.g[ch];
      if (!g) continue;
      items.push([g, x + g[3]]);
      x += g[2];
    }
    var fixed = 0, flex = 0;
    set.parts.forEach(function (o) { if (o.s) flex += o.w; else fixed += o.w; });
    var total = Math.max(set.ox + x * set.hx + set.rightPad, fixed + 4);
    var k = (total - fixed) / flex;
    var dpr = window.devicePixelRatio || 1;
    var CW = cv.clientWidth, CH = cv.clientHeight;
    if (!CW || !CH) return;
    cv.width = Math.round(CW * dpr);
    cv.height = Math.round(CH * dpr);
    var c = cv.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    c.clearRect(0, 0, CW, CH);
    var sc = Math.min(CH / set.h, CW / total);
    var ox = (CW - total * sc) / 2, oy = (CH - set.h * sc) / 2;
    c.imageSmoothingQuality = 'high';
    var px = 0;
    set.parts.forEach(function (o, i) {
      var w = o.s ? o.w * k : o.w;
      var src = im[o.file];
      if (o.s) {
        var band = document.createElement('canvas');
        band.width = Math.max(1, Math.round(w));
        band.height = set.h;
        band.getContext('2d').drawImage(src, 0, 0, o.w, set.h, 0, 0, band.width, set.h);
        src = band;
      }
      if (w > 0) c.drawImage(src, ox + px * sc - (i ? 0.5 : 0), oy, w * sc + (i < set.parts.length - 1 ? 1 : 0), set.h * sc);
      px += w;
    });
    var tx = ox + set.ox * sc;
    items.forEach(function (o) {
      var g = o[0];
      c.drawImage(im[set.sheet], g[0], 0, g[1], set.lh, tx + o[1] * set.hx * sc, oy + set.oy * sc, g[1] * set.hx * sc, set.lh * sc);
    });
    len.textContent = 'About ' + (Math.round(total / set.h * 30) / 10).toString().replace('.', ',') + ' cm long, 3 cm high';
  }

  function findBox(root, re) {
    return Array.prototype.find.call(root.querySelectorAll('.ymq-options-box'), function (b) {
      return re.test(b.getAttribute('ymq-option-label') || '');
    });
  }

  cfg.api = {
    load: load,
    draw: draw,
    clean: clean,
    ready: function () { return !!data; },
    max: function (p) { return data && data[p] ? data[p].max : 30; }
  };
  if (window.CGX_POCKET) return;

  function build() {
    var root = document.querySelector('.product-form__buttons ymq-option');
    if (!root) return false;
    if (root.querySelector('.ss')) return true;
    var found = [];
    PLATFORMS.forEach(function (pl) {
      var box = findBox(root, pl.handle);
      var field = box && box.querySelector('input.ymq-input-text, input[type="text"]');
      if (field) found.push({ key: pl.key, box: box, field: field });
    });
    if (!found.length) return false;

    var rows = found.map(function (f) {
      f.box.classList.add('ss-box');
      f.field.setAttribute('autocapitalize', 'characters');
      f.field.setAttribute('autocomplete', 'off');
      f.field.setAttribute('spellcheck', 'false');
      if (!f.field.placeholder) f.field.placeholder = 'YOURNAME';
      var stage = document.createElement('div');
      stage.className = 'ss ss-stage';
      stage.hidden = true;
      stage.setAttribute('aria-live', 'polite');
      stage.innerHTML = '<canvas role="img" aria-label="Sticker preview"></canvas><small></small>';
      var wrap = f.field.closest('.ymq-option-text-input-wrapper, .ymq-option-input-wrapper') || f.field;
      wrap.insertAdjacentElement('afterend', stage);
      f.stage = stage;
      f.field.addEventListener('input', function () {
        var max = data && data[f.key] ? data[f.key].max : 30;
        var v = clean(f.field.value, max);
        if (v !== f.field.value) {
          var pos = f.field.selectionStart;
          var before = clean(f.field.value.slice(0, pos), max).length;
          f.field.value = v;
          try { f.field.setSelectionRange(before, before); } catch (e) {}
        }
        render();
      });
      return f;
    });

    function render() {
      if (!data) return;
      rows.forEach(function (f) {
        if (!data[f.key]) return;
        f.stage.hidden = false;
        if (f.box.style.display === 'none') return;
        var text = clean(f.field.value, data[f.key].max) || 'YOURNAME';
        draw(f.stage.querySelector('canvas'), f.stage.querySelector('small'), f.key, text);
      });
    }

    var started = false;
    function start() {
      if (started) return;
      started = true;
      load().then(render).catch(function () {
        rows.forEach(function (f) { f.box.classList.remove('ss-box'); f.stage.remove(); });
      });
    }
    root.addEventListener('click', start);
    root.addEventListener('focusin', start);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '300px' });
      io.observe(root);
    } else {
      start();
    }
    new MutationObserver(function () { if (data) requestAnimationFrame(render); })
      .observe(root, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(render, 150); });
    return true;
  }

  function attempt() {
    if (build()) return;
    tries++;
    if (tries < 75) setTimeout(attempt, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }
})();
